module.exports = __webpack_public_path__ + "img/medi.0b421c3e.jpg";